import { AlpineBindingContext, AlpineComponent } from "@nxtlvlsoftware/alpine-typescript/";

export class ExtendedAlpineComponent extends AlpineComponent {
    protected binding<HiddenKeys extends string = ''>(bindings: AlpineBindingContext<this, keyof this, HiddenKeys> & ThisType<this>): AlpineBindingContext<this, keyof this, HiddenKeys>
    {
        return super.binding(bindings);
    }
}